import NotificationPreferences from './NotificationPreferences';
import VatRegistrationSection from './VatRegistrationSection';

export default function AccountSettingsTab() {
  return (
    <div className="settings-tab-content">
      <NotificationPreferences />
      <VatRegistrationSection />
    </div>
  );
}
